import * as React from 'react'
import type { SVGProps } from 'react'
const SignOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.25 4.375H5.25V23.625H12.25'
      stroke='#CECECE'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M12.25 14H24.5'
      stroke='#CECECE'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M20.125 9.625L24.5 14L20.125 18.375'
      stroke='#CECECE'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
export default SignOut
